import LaunchIcon from '@mui/icons-material/Launch';
import { Avatar, Box, IconButton, MenuItem, MenuList, Stack, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { CustomPopover } from '@components/CustomPopover';
import Divider from '@components/Divider';
import { useMe } from '@hooks/useMe';
import { usePopover } from '@hooks/usePopover';
import { useUserPermissions } from '@hooks/useUserPermissions';
import { Roles } from '@rdTypes/shared';
import { identityServer, userRoutes } from '@routes';
import { useAuth } from 'src/routes/Auth/authContext';

import { SettingsDrawer } from './SettingsDrawer';
import { styles } from './styles';

const OPTIONS = [
  {
    label: 'Home',
    linkTo: '/',
  },
  {
    label: 'Profile',
    linkTo: userRoutes.account(),
  },
];

export const AccountPopover = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { logout } = useAuth();
  const { currentUser } = useMe();
  const { isAllowed } = useUserPermissions();
  const [settingsOpen, setSettingsOpen] = useState(false);

  const popOver = usePopover();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error(error);
      // enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  const handleClickItem = (path: string) => {
    popOver.onClose();
    navigate(path);
  };

  const openAccountManagement = () => {
    window.open(identityServer.manage, '_blank');
    popOver.onClose();
  };

  const {
    iconButtonSx,
    avatarSx,
    popOverSx,
    popOverBoxSx,
    userNameSx,
    launchIconSx,
    stackSx,
    menuItemStackSx,
  } = styles(theme);

  return (
    <>
      <IconButton onClick={popOver.onOpen} sx={iconButtonSx(popOver.open)} aria-label="Account menu">
        <Avatar src={currentUser?.profileImageUrl || undefined} alt={currentUser?.userName} sx={avatarSx}>
          {currentUser?.userName}
        </Avatar>
      </IconButton>

      <CustomPopover open={popOver.open} onClose={popOver.onClose} anchorEl={popOver.anchorEl} sx={popOverSx}>
        <Box sx={popOverBoxSx}>
          <Typography variant="subtitle2" noWrap>
            {currentUser?.displayName}
          </Typography>

          <Typography variant="body2" sx={userNameSx} noWrap>
            @{currentUser?.userName}
          </Typography>
        </Box>

        <Divider dashed />

        <MenuList sx={stackSx}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}

          {isAllowed([Roles.Mailroom]) && (
            <MenuItem
              onClick={() => {
                popOver.onClose();
                setSettingsOpen(true);
              }}
            >
              Settings
            </MenuItem>
          )}

          <MenuItem onClick={openAccountManagement}>
            <Stack sx={menuItemStackSx}>
              <Box>Manage Account</Box>
              <LaunchIcon sx={launchIconSx} />
            </Stack>
          </MenuItem>
                  <Divider dashed />

        <MenuItem onClick={handleLogout} sx={menuItemStackSx}>
          Logout
        </MenuItem>
        </MenuList>


      </CustomPopover>

      <SettingsDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
};
